/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Supplyairhumiditydefect3Inputs */



/**
* | output |
* | --- |
* | "Supply air humidity sensor fault" |
*
* @param {Ahu_History_Key_Supplyairhumiditydefect3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_supplyairhumiditydefect3 = /** @type {((inputs?: Ahu_History_Key_Supplyairhumiditydefect3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Supplyairhumiditydefect3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Supply air humidity sensor fault")
	return /** @type {LocalizedString} */ ("Défaut sonde hygrométrie air soufflé")
});
export { ahu_history_key_supplyairhumiditydefect3 as "ahu_history_key_supplyAirHumidityDefect" }